var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-659 -495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M688.02,499.99a16.689,16.689,0,0,0-4.65-3.31c-.5-.24-1.01-.46-1.53-.65a16.839,16.839,0,0,0-3.25-.83,16.87,16.87,0,0,0-5.18,0,16.839,16.839,0,0,0-3.25.83c-.52.2-1.03.41-1.53.65a17.029,17.029,0,0,0-7.95,7.95c-.24.5-.45,1.01-.65,1.53a17.116,17.116,0,0,0,0,11.68c.2.52.41,1.03.65,1.53a17.029,17.029,0,0,0,7.95,7.95c.5.24,1.01.45,1.53.65A17.228,17.228,0,0,0,676,529a17.075,17.075,0,0,0,2.59-.2,16.839,16.839,0,0,0,3.25-.83c.52-.19,1.03-.41,1.53-.65a16.689,16.689,0,0,0,4.65-3.31,16.972,16.972,0,0,0,0-24.02ZM676,527a15,15,0,1,1,15-15A15.018,15.018,0,0,1,676,527Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677,505h-2v6h-6v2h6v6h2v-6h6v-2h-6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.1e80fd0e6fae019da7ff9669decfc863.svg";
export { ForwardRef as ReactComponent };